import { SEARCH_QUERY_PARAM_NAME } from "src/constants/UrlConstants";
import { ROUTE_PATHS } from "./constants";
import { GridSummaryDto, UniverseDto } from "src/api/search/api";

const space = /\s+/gi;
const categoryUrlRegex = /.*-l([0-9]+)/;

export const encodePathFragment = (fragment: string) => encodeURIComponent(fragment?.replace(space, '-'));

export const getCategoryUrl = (universe: UniverseDto, grid: GridSummaryDto) => 
    `${ROUTE_PATHS.PRODUCTS}/${encodePathFragment(universe?.name)}-l${universe?.id}/${encodePathFragment(grid?.name)}-l${grid?.id}`;

export const getURLFragmentId = (paramId: string) => {
   if (categoryUrlRegex.exec(paramId)?.length >= 1) {
       return categoryUrlRegex.exec(paramId)[1];
   }
   return null
};

const encodeSearchPathFragment = (fragment: string) => encodeURIComponent(fragment);

export const setSearchUrl = (universe: UniverseDto, searchQueryParam: string) => {
    const asd = /\-/gi;
    const sufix = searchQueryParam ? `?${SEARCH_QUERY_PARAM_NAME}=${encodeSearchPathFragment(searchQueryParam)}` : "";
    return `${ROUTE_PATHS.SEARCH}/${encodePathFragment(universe?.name)}${sufix}`;
};